(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { MediaContext } from "../../helpers/responsive";
import { SPACE, BORDER } from "../../constants/style";

var ConditionalWrapper = function ConditionalWrapper(_ref) {
  var condition = _ref.condition,
      wrapper = _ref.wrapper,
      children = _ref.children;
  return condition ? wrapper(children) : children;
};

var MuiThemeThemeProvider = function MuiThemeThemeProvider(props) {
  var children = props.children,
      theme = props.theme;
  var muiTheme = createTheme({
    typography: {
      fontFamily: 'Mabry Pro'
    },
    palette: {
      error: {
        main: theme.styles.colors.errorColor
      },
      primary: {
        main: theme.styles.colors.primaryColor,
        dark: theme.styles.colors.primaryFadedColor
      },
      text: {
        primary: theme.styles.colors.bodyTextColor,
        secondary: theme.styles.colors.bodySecondaryTextColor
      }
    },
    divider: theme.styles.colors.primaryFadedColor,
    props: {
      MuiButtonBase: {
        disableRipple: true
      }
    },
    overrides: {
      MuiIconButton: {
        root: {
          '&&&:hover': {
            backgroundColor: 'transparent'
          }
        }
      },
      MuiSelect: {
        icon: {
          color: theme.styles.colors.bodySecondaryTextColor
        }
      },
      MuiInputLabel: {
        root: {
          fontWeight: 700
        },
        outlined: {
          transform: 'translate(14px, 16px) scale(1)',
          paddingRight: '0px',
          '&$shrink': {
            paddingRight: '8px',
            transform: 'translate(14px, -6px) scale(0.8)'
          }
        }
      },
      MuiFormLabel: {
        root: {
          '&$focused': {
            color: "".concat(theme.styles.colors.secondaryColor, " !important")
          }
        }
      },
      MuiInputBase: {
        root: {
          color: theme.styles.colors.bodySecondaryTextColor,
          fontWeight: 700
        }
      },
      MuiInputAdornment: {
        root: {
          color: theme.styles.colors.bodySecondaryTextColor
        },
        positionStart: {
          marginRight: SPACE.sm
        },
        positionEnd: {
          marginLeft: SPACE.sm
        }
      },
      MuiPaper: {
        root: {
          backgroundColor: theme.styles.colors.backgroundAlternate,
          color: theme.styles.colors.bodySecondaryTextColor
        }
      },
      MuiOutlinedInput: {
        input: {
          paddingTop: '14.5px',
          paddingBottom: '14.5px'
        },
        notchedOutline: {
          borderWidth: '2px',
          borderColor: "".concat(theme.styles.colors.secondaryColor, " !important"),
          transition: 'border-color 0.15s',
          fontSize: '1.05em'
        }
      },
      MuiAutocomplete: {
        popupIndicator: {
          padding: '2px !important'
        },
        clearIndicator: {
          padding: '4px !important'
        },
        root: {
          '&& $inputRoot': {
            padding: '6px 8px'
          },
          '&&&& $input': {
            padding: '8.5px 4px'
          }
        },
        tag: {
          height: '26px',
          borderRadius: '4px',
          paddingLeft: 6,
          paddingRight: 6
        }
      },
      MuiChip: {
        root: {
          backgroundColor: theme.styles.colors.primary,
          color: theme.styles.colors.bodyFilledTextColor
        },
        label: {
          paddingLeft: 2,
          paddingRight: 12
        },
        deleteIcon: {
          marginRight: -2,
          color: theme.styles.colors.bodyFilledTextColor,
          width: 16,
          height: 16,
          stroke: 'unset',
          '&&:hover': {
            color: theme.styles.colors.bodyFilledTextColor
          }
        }
      },
      MuiCheckbox: {
        root: {
          color: theme.styles.colors.tertiary,
          '&$checked': {
            color: theme.styles.colors.tertiary
          }
        },
        colorPrimary: {
          color: theme.styles.colors.tertiary,
          '&$checked': {
            color: theme.styles.colors.primary
          }
        },
        colorSecondary: {
          color: theme.styles.colors.tertiary,
          '&$checked': {
            color: theme.styles.colors.secondary
          }
        }
      },
      MuiRadio: {
        root: {
          color: theme.styles.colors.tertiary,
          '&$checked': {
            color: theme.styles.colors.tertiary
          }
        },
        colorPrimary: {
          color: theme.styles.colors.tertiary,
          '&$checked': {
            color: theme.styles.colors.primary
          }
        },
        colorSecondary: {
          color: theme.styles.colors.tertiary,
          '&$checked': {
            color: theme.styles.colors.secondary
          }
        }
      },
      MuiSwitch: {
        root: {
          width: 45,
          height: 24,
          padding: 0,
          display: 'flex'
        },
        switchBase: {
          padding: 4,
          height: 24,
          backgroundColor: 'transparent',
          color: theme.styles.colors.tertiary,
          colorSecondary: {
            color: theme.styles.colors.tertiary,
            '&$checked': {
              color: theme.styles.colors.tertiary
            }
          },
          '&$checked': {
            transform: 'translateX(20.5px)',
            color: theme.styles.colors.primaryColor,
            '& + $track': {
              opacity: 1,
              backgroundColor: 'transparent',
              borderColor: theme.styles.colors.primaryColor
            }
          }
        },
        thumb: {
          width: 16,
          height: 16,
          boxShadow: 'none'
        },
        track: {
          border: "2px solid ".concat(theme.styles.colors.tertiary),
          borderRadius: 24 / 2,
          opacity: 1,
          backgroundColor: 'transparent',
          height: 24
        },
        checked: {}
      },
      MuiPickersDay: {
        day: {
          borderRadius: BORDER.radius.sm
        },
        daySelected: {
          '&&&:hover': {
            backgroundColor: theme.styles.colors.primaryColor
          }
        }
      },
      MuiPickersCalendarHeader: {
        iconButton: {
          backgroundColor: 'transparent'
        }
      },
      MuiTooltip: {
        tooltip: {
          backgroundColor: theme.styles.colors.secondaryColor,
          fontSize: '14px'
        },
        arrow: {
          color: theme.styles.colors.secondaryColor
        }
      },
      MuiTabs: {
        root: {
          borderBottom: 'transparent',
          backgroundColor: 'transparent'
        },
        indicator: {
          backgroundColor: theme.styles.colors.secondaryColor,
          bottom: '4px'
        }
      },
      MuiTab: {
        root: {
          fontFamily: theme.styles.fonts.primary,
          fontWeight: 400,
          padding: 0,
          textTransform: 'none',
          marginRight: '24px',
          minWidth: 0,
          '@media (min-width: 600px)': {
            minWidth: 0
          },
          fontSize: '18px',
          '&$selected': {
            color: theme.styles.colors.secondaryColor
          }
        }
      },
      MuiButtonBase: {
        root: {
          fontFamily: 'Mabry Pro',
          fontSize: '16px',
          fontWeight: 400,
          borderRadius: '4px'
        }
      },
      MuiPagination: {},
      MuiPaginationItem: {
        root: {
          fontFamily: null,
          // To inherit from MuiButtonBase instead of theme default
          fontWeight: null,
          fontSize: null,
          padding: '0 16px',
          margin: 0,
          transition: null,
          borderRadius: '4px',
          '&$selected': {
            backgroundColor: theme.styles.colors.primaryColor,
            color: '#2A0062'
          },
          height: '40px'
        },
        page: {
          borderRadius: '4px',
          transition: null,
          '&$selected': {
            backgroundColor: theme.styles.colors.primaryColor,
            color: '#2A0062',
            '&:hover': {
              backgroundColor: theme.styles.colors.primaryColor
            }
          },
          '&:hover': {
            backgroundColor: 'transparent'
          }
        }
      }
    }
  });
  return React.createElement(MuiThemeProvider, {
    theme: muiTheme
  }, children);
};

var ThemeProvider = function ThemeProvider(props) {
  var children = props.children,
      theme = props.theme;
  return React.createElement(MediaContext.Provider, {
    value: "mobile"
  }, React.createElement(ConditionalWrapper, {
    condition: theme,
    wrapper: function wrapper(children) {
      return React.createElement(StyledComponentsThemeProvider, {
        theme: theme
      }, React.createElement(MuiThemeThemeProvider, {
        theme: theme
      }, children));
    }
  }, children));
};

var _default = ThemeProvider;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ConditionalWrapper, "ConditionalWrapper", "/home/vsts/work/1/s/src/components/themes/ThemeProvider.js");
  reactHotLoader.register(MuiThemeThemeProvider, "MuiThemeThemeProvider", "/home/vsts/work/1/s/src/components/themes/ThemeProvider.js");
  reactHotLoader.register(ThemeProvider, "ThemeProvider", "/home/vsts/work/1/s/src/components/themes/ThemeProvider.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/themes/ThemeProvider.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();